import React from "react";
import LogoSvg from "./logo_svg";
import { Link } from "gatsby";

const Logo = () => {
  return (
    <>
      <Link to="/">
        <LogoSvg />
      </Link>
      <div className="logo-description">
        <p className="my-1 text-blue-darkest italic">
          <Link
            className="text-blue-darker hover:text-blue no-underline"
            to="/"
          >
            Juan Francisco Andrade A.
          </Link>
        </p>
        <p className=" tracking-wide">
          <Link
            className="text-orange-darker hover:text-orange no-underline"
            to="/"
          >
            BLOG
          </Link>
        </p>
      </div>
    </>
  );
};

export default Logo;
